import React from "react";
import IntroPage from "./IntroPage";
import Service from "./Designs";
import Feature from "./Feature";
import TabsDemo from "./UI_Components/tabs";
import BackgroundBeams from "./UI/backgroundBeams";

function LandingPage() {
  return (
    <section className="bg-black">
      <div className="relative overflow-x-hidden w-full flex flex-col justify-center items-center h-full max-w-[130rem]  mx-auto">
        <IntroPage />
        <div className=" bg-black">
          <Service />
        </div>
        <div>
          <Feature />
        </div>
        <div className="flex justify-center items-center w-screen">
          <TabsDemo />
        </div>
      </div>

      <BackgroundBeams />
    </section>
  );
}

export default LandingPage;
